import React, { useContext, useEffect, useState } from 'react';
import SHARED from '../../constants';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
import styles from './styles.module.css';

const AudioPlayer = ({
  id,
  src,
  onClick,
  // setActiveMessage,
  // activeMessage,
  control,
  item,
  extraStyle,
  extraId = '',
  // playing,
  // setPlaying,
}) => {
  // let audio;
  // let progress;
  let play = false;
  // const [playing, setPlaying] = useState(false);
  const {
    setActiveAudio,
    setActiveMessage,
    playing,
    setPlaying,
    seekValue,
    setSeekValue,
    activeMessage,
  } = useContext(AdminContext);
  // useEffect(() => {
  //   let allAudios = document.getElementsByTagName('audio');

  //   if (activeMessage == id) {
  //     let audio = document.getElementById(`this${id}`);
  //     let progress = document.getElementById(`progress${id}`);

  //     console.log(
  //       'audio',
  //       audio,
  //       audio.currentTime,
  //       audio.duration,
  //       progress?.value,
  //       activeMessage,
  //       id
  //     );
  //     play = true;
  //     setPlaying(true);
  //     audio.currentTime = 0;
  //     progress.value = 0;
  //     audio.play();
  //   }
  // }, [activeMessage, id, control]);
  // const playFunction = () => {
  //   let audio = document.getElementById(`this${id}`);
  //   // let progress = document.getElementById(`progress${id}`);
  //   console.log('idd', id);
  //   if (activeMessage != id) {
  //     setActiveMessage(id);
  //   } else {
  //     if (audio) {
  //       audio.play();
  //       play = true;
  //       setPlaying(true);
  //     }
  //   }
  // };
  useEffect(() => {
    const hiddenAudio = document.getElementById('hiddenAudio');
    if (playing) {
      hiddenAudio.play();
    } else {
      hiddenAudio.pause();
    }
    // hiddenAudio.pause();
  }, [playing]);

  const playFunction = () => {
    // let actual = document.getElementById(`this${activeAudio?.id}`);
    // let actualseek = document.getElementById(`progress${activeAudio?.id}`);

    // let audio = document.getElementById(`${id}`);
    // let progress = document.getElementById(`hiddenAudioSeekbar`);

    // const hiddenAudio = document.getElementById('hiddenAudio');
    // hiddenAudio.src = `${SHARED?.socketServerMusic}${item?.file?.name}`;
    // if (activeMessage?.id != id) {
    //   setActiveMessage(id);
    //   setActiveAudio(item);
    //   console.log('hiddenAudio', hiddenAudio);
    //   hiddenAudio.src = `${SHARED?.socketServerMusic}${item?.file?.name}`;
    // }

    // hiddenAudio?.play();
    setPlaying(true);
  };
  const pauseFunction = () => {
    // let audio = document.getElementById(`this${id}`);
    // let progress = document.getElementById(`progress${id}`);
    // console.log('playing==', audio.playing, audio);

    // audio.pause();
    // play = false;
    setPlaying(false);
    // const hiddenAudio = document.getElementById('hiddenAudio');
    // hiddenAudio.pause();
  };
  // const onTimeUpdateFunction = () => {
  //   const hiddenAudio = document.getElementById('hiddenAudio');
  //   let audio = document.getElementById(`this${id}`);
  //   let progress = document.getElementById(`progress${id}`);
  //   if (progress && hiddenAudio.duration) {
  //     progress.value = (hiddenAudio.currentTime / hiddenAudio.duration) * 100;
  //     // hiddenAudio.seekbar=progress;
  //   }
  // };
  // useEffect(() => {
  //   if (playing) {
  //     hiddenAudio?.play();
  //   } else {
  //     hiddenAudio?.pause();
  //   }
  // }, [activeAudio]);
  const changeProggress = () => {
    let audio = document.getElementById(`this${id}`);
    let progress = document.getElementById(`progress${id}`);

    const hiddenAudio = document.getElementById('hiddenAudio');

    const hiddenAudioSeekbar = document.getElementById('hiddenAudioSeekbar');

    if (hiddenAudio && hiddenAudioSeekbar) {
      hiddenAudio.currentTime = (progress.value * hiddenAudio.duration) / 100;

      // setSeekValue((progress.value * hiddenAudio.duration) / 100);
      setSeekValue(progress.value);
    }

    // if (audio.duration && progress) {
    //   audio.currentTime = (progress.value * audio.duration) / 100;
    // } else {
    //   false;
    // }
  };
  // console.log('playing', playing, control, seekValue);
  // console.log('seekValue', seekValue);
  return (
    <>
      <div className={`${styles.player} ${extraStyle}`}>
        <div className={styles.controls} id={`this${id}`}>
          <div className={`${styles.play} playMusic`}>
            <>
              {!playing ? (
                <AppIcons.PlayIcon
                  onClick={() => {
                    // setActiveMessage(id);
                    // setActiveAudio(item);

                    playFunction();
                  }}
                  width={`13px`}
                  height={`13px`}
                  className={`${styles.icon} noFilterSvg `}
                />
              ) : (
                <AppIcons.PauseIcon
                  onClick={() => pauseFunction()}
                  className={`${styles.icon} noFilterSvg `}
                  width={`13px`}
                  height={`13px`}
                />
              )}
            </>
          </div>

          <input
            id={`progress${id}`}
            type="range"
            onChange={(e) => {
              const hiddenAudio = document.getElementById('hiddenAudio');

              const hiddenAudioSeekbar =
                document.getElementById('hiddenAudioSeekbar');
              if (
                hiddenAudio?.currentTime &&
                hiddenAudioSeekbar &&
                hiddenAudio?.duration
              ) {
                changeProggress();
              } else {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
            className={`e-range`}
            value={
              document.getElementById('hiddenAudio')?.currentTime
                ? seekValue
                : 0
            }
            // value={0}
          />
        </div>
      </div>
    </>
  );
};

export default AudioPlayer;
